import React from 'react';
import { View, Text } from 'react-native';

const HomePageMasonryList = () => {
  return (
    <View >
      <Text>Hello</Text>
    </View>
  );
};

export default HomePageMasonryList;